import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    documentos: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const GET_ALL_DOCUMENTOS = 'GET_ALL_DOCUMENTOS'
const GET_DOCUMENTOS_BY_LOTE = 'GET_DOCUMENTOS_BY_LOTE'
const DELETE_DOCUMENTO = 'DELETE_DOCUMENTO'
const GET_DOCUMENTOS_BY_ANALISIS = 'GET_DOCUMENTOS_BY_ANALISIS'

//*******************************************************************************************************************


//METODOS
export const obtenerDocumentos = createAsyncThunk(
    GET_ALL_DOCUMENTOS,
    async () => {
        try {
            const fullUrl = host + `DocumentosLote/obtenerDocumentos`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDocumentosByLote = createAsyncThunk(
    GET_DOCUMENTOS_BY_LOTE,
    async (data) => {
        try {
            const fullUrl = host + `DocumentosLote/obtenerDocumentosByLote`
            const res = await axios.post(fullUrl, data)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDocumentosByAnalisis = createAsyncThunk(
    GET_DOCUMENTOS_BY_ANALISIS,
    async (data) => {
        try {
            const fullUrl = host + `DocumentosLote/obtenerDocumentosByAnalisis`
            const res = await axios.post(fullUrl, data)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarDocumento = createAsyncThunk(
    DELETE_DOCUMENTO,
    async (idlotesdocumentos) => {
        try {
            const fullUrl = host + `DocumentosLote/eliminarDocumento/${idlotesdocumentos}`
            //alert(JSON.stringify(data))
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosDocumentosLoteSlice = createSlice({

    name: 'metodosDocumentosLoteSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerDocumentos.fulfilled]: (state, { payload }) => {
            state.asociadolocalidad = payload.data.data
        },
        [obtenerDocumentosByLote.fulfilled]: (state, { payload }) => {
        },
        [obtenerDocumentosByAnalisis.fulfilled]: (state, { payload }) => {
        },
        [eliminarDocumento.fulfilled]: (state, { payload }) => {
        }
    },

})

export const { } = metodosDocumentosLoteSlice.actions
export const DocumentosLoteReducer = metodosDocumentosLoteSlice.reducer